import { Link } from 'react-router-dom';

function LogoConcept1() {
  return (
    <div className="flex items-center gap-3">
      {/* X as crossed sails */}
      <div className="relative w-12 h-12 flex items-center justify-center">
        {/* Left sail of X */}
        <div
          className="absolute"
          style={{
            width: 0,
            height: 0,
            borderLeft: '14px solid transparent',
            borderRight: '4px solid transparent',
            borderBottom: '44px solid #1a1a1a',
            top: 2,
            left: 4,
            transform: 'rotate(-8deg)',
          }}
        />
        {/* Right sail of X - red accent */}
        <div
          className="absolute"
          style={{
            width: 0,
            height: 0,
            borderLeft: '4px solid transparent',
            borderRight: '14px solid transparent',
            borderBottom: '44px solid #dc2626',
            top: 2,
            right: 4,
            transform: 'rotate(8deg)',
          }}
        />
      </div>
      <div className="flex flex-col leading-none">
        <span className="font-black text-2xl tracking-tight text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          MAX
        </span>
        <span className="font-bold text-xs tracking-[0.25em] text-gray-500 uppercase mt-0.5">
          SAILS CANADA
        </span>
      </div>
    </div>
  );
}

function LogoConcept2() {
  return (
    <div className="flex items-center gap-3">
      <div className="relative">
        {/* MAX text with speed lines overlay */}
        <span
          className="font-black text-3xl tracking-tight text-gray-900 relative z-10"
          style={{ fontFamily: "'Montserrat', sans-serif", letterSpacing: '-0.02em' }}
        >
          MAX
        </span>
        {/* Speed lines */}
        <div className="absolute inset-0 flex flex-col justify-center gap-1 pointer-events-none" style={{ top: 4 }}>
          <div className="h-[2px] bg-red-600" style={{ width: '110%', marginLeft: '-5%', opacity: 0.85, transform: 'rotate(-6deg)' }} />
          <div className="h-[2px] bg-red-600" style={{ width: '90%', marginLeft: '5%', opacity: 0.6, transform: 'rotate(-6deg)' }} />
        </div>
      </div>
      {/* Sail silhouette */}
      <div className="flex flex-col items-start">
        <div
          style={{
            width: 0,
            height: 0,
            borderLeft: '10px solid transparent',
            borderRight: '0px solid transparent',
            borderBottom: '28px solid #dc2626',
            marginBottom: 2,
          }}
        />
        <span className="font-semibold text-xs tracking-[0.3em] text-gray-500 uppercase">
          SAILS
        </span>
      </div>
    </div>
  );
}

function LogoConcept3() {
  return (
    <div className="flex items-center gap-4">
      {/* Geometric sail mark */}
      <div className="relative flex items-end" style={{ width: 36, height: 44 }}>
        {/* Mast */}
        <div className="absolute left-[6px] bottom-0 w-[2px] bg-gray-800" style={{ height: 44 }} />
        {/* Sail triangle */}
        <div
          className="absolute"
          style={{
            width: 0,
            height: 0,
            borderTop: '0px solid transparent',
            borderBottom: '38px solid #dc2626',
            borderLeft: '0px solid transparent',
            borderRight: '28px solid transparent',
            bottom: 0,
            left: 8,
          }}
        />
        {/* Boom (horizontal base) */}
        <div className="absolute bottom-0 left-[6px] h-[2px] bg-gray-800" style={{ width: 30 }} />
      </div>
      {/* Text */}
      <div className="flex flex-col leading-none">
        <span className="font-black text-2xl tracking-tight text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          MAX SAILS
        </span>
        <span className="font-medium text-[10px] tracking-[0.35em] text-gray-400 uppercase mt-1">
          CANADA
        </span>
      </div>
    </div>
  );
}

export default function LogoPreviewPage() {
  return (
    <div className="min-h-screen bg-stone-50 py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12 text-center">
          <p className="text-red-600 text-xs uppercase tracking-[0.3em] font-semibold mb-3">Logo Concepts</p>
          <h1 className="text-4xl font-black text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            MAX Sails — 3 Logo Options
          </h1>
          <p className="text-gray-500 mt-3 text-sm">Pick your favourite and we'll apply it across the whole site.</p>
        </div>

        <div className="space-y-6">
          {/* Concept 1 */}
          <div className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
            <div className="px-8 py-5 border-b border-stone-100 flex items-center justify-between">
              <div>
                <span className="text-xs font-bold uppercase tracking-widest text-red-600">Concept 1</span>
                <h2 className="text-lg font-black text-gray-900 mt-0.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>The X Sail</h2>
                <p className="text-gray-400 text-xs mt-1">The X becomes two crossed sail shapes — one charcoal, one red</p>
              </div>
            </div>
            {/* Light bg preview */}
            <div className="flex flex-col sm:flex-row">
              <div className="flex-1 flex items-center justify-center py-12 bg-white">
                <LogoConcept1 />
              </div>
              <div className="flex-1 flex items-center justify-center py-12 bg-gray-900">
                <div className="flex items-center gap-3">
                  <div className="relative w-12 h-12 flex items-center justify-center">
                    <div className="absolute" style={{ width: 0, height: 0, borderLeft: '14px solid transparent', borderRight: '4px solid transparent', borderBottom: '44px solid #ffffff', top: 2, left: 4, transform: 'rotate(-8deg)' }} />
                    <div className="absolute" style={{ width: 0, height: 0, borderLeft: '4px solid transparent', borderRight: '14px solid transparent', borderBottom: '44px solid #dc2626', top: 2, right: 4, transform: 'rotate(8deg)' }} />
                  </div>
                  <div className="flex flex-col leading-none">
                    <span className="font-black text-2xl tracking-tight text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>MAX</span>
                    <span className="font-bold text-xs tracking-[0.25em] text-white/50 uppercase mt-0.5">SAILS CANADA</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Concept 2 */}
          <div className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
            <div className="px-8 py-5 border-b border-stone-100">
              <span className="text-xs font-bold uppercase tracking-widest text-red-600">Concept 2</span>
              <h2 className="text-lg font-black text-gray-900 mt-0.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>Speed Lines</h2>
              <p className="text-gray-400 text-xs mt-1">Bold MAX text sliced by red speed lines + a small sail mark</p>
            </div>
            <div className="flex flex-col sm:flex-row">
              <div className="flex-1 flex items-center justify-center py-12 bg-white">
                <LogoConcept2 />
              </div>
              <div className="flex-1 flex items-center justify-center py-12 bg-gray-900">
                <div className="flex items-center gap-3">
                  <div className="relative">
                    <span className="font-black text-3xl tracking-tight text-white relative z-10" style={{ fontFamily: "'Montserrat', sans-serif", letterSpacing: '-0.02em' }}>MAX</span>
                    <div className="absolute inset-0 flex flex-col justify-center gap-1 pointer-events-none" style={{ top: 4 }}>
                      <div className="h-[2px] bg-red-500" style={{ width: '110%', marginLeft: '-5%', opacity: 0.85, transform: 'rotate(-6deg)' }} />
                      <div className="h-[2px] bg-red-500" style={{ width: '90%', marginLeft: '5%', opacity: 0.6, transform: 'rotate(-6deg)' }} />
                    </div>
                  </div>
                  <div className="flex flex-col items-start">
                    <div style={{ width: 0, height: 0, borderLeft: '10px solid transparent', borderRight: '0px solid transparent', borderBottom: '28px solid #dc2626', marginBottom: 2 }} />
                    <span className="font-semibold text-xs tracking-[0.3em] text-white/50 uppercase">SAILS</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Concept 3 */}
          <div className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
            <div className="px-8 py-5 border-b border-stone-100">
              <span className="text-xs font-bold uppercase tracking-widest text-red-600">Concept 3</span>
              <h2 className="text-lg font-black text-gray-900 mt-0.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>Minimal Sail Mark</h2>
              <p className="text-gray-400 text-xs mt-1">A clean geometric sail triangle with mast — timeless and versatile</p>
            </div>
            <div className="flex flex-col sm:flex-row">
              <div className="flex-1 flex items-center justify-center py-12 bg-white">
                <LogoConcept3 />
              </div>
              <div className="flex-1 flex items-center justify-center py-12 bg-gray-900">
                <div className="flex items-center gap-4">
                  <div className="relative flex items-end" style={{ width: 36, height: 44 }}>
                    <div className="absolute left-[6px] bottom-0 w-[2px] bg-white" style={{ height: 44 }} />
                    <div className="absolute" style={{ width: 0, height: 0, borderTop: '0px solid transparent', borderBottom: '38px solid #dc2626', borderLeft: '0px solid transparent', borderRight: '28px solid transparent', bottom: 0, left: 8 }} />
                    <div className="absolute bottom-0 left-[6px] h-[2px] bg-white" style={{ width: 30 }} />
                  </div>
                  <div className="flex flex-col leading-none">
                    <span className="font-black text-2xl tracking-tight text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>MAX SAILS</span>
                    <span className="font-medium text-[10px] tracking-[0.35em] text-white/40 uppercase mt-1">CANADA</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-400 text-sm mb-4">Which one do you like? Just tell me the concept number and I'll apply it to the whole site!</p>
          <Link to="/" className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-stone-200 text-gray-600 text-sm hover:bg-stone-100 transition-colors cursor-pointer">
            <i className="ri-arrow-left-line" />
            Back to Site
          </Link>
        </div>
      </div>
    </div>
  );
}
